import React from 'react'

import OurRoutes from './Routes';
import * as Routers from './Routers';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

function AppRouter() {
  return (
    <>
      <Router>
        <Routes>
          <Route path={OurRoutes.Homepage} element={<Routers.Homepage />} />
          <Route path={OurRoutes.TERMS_CONDITIONS} element={<Routers.TERMS_CONDITIONS />} />
          <Route path={OurRoutes.PRIVACY_POLICY} element={<Routers.PRIVACY_POLICY />} />
        </Routes>
      </Router>
    </>
  );
}

export default AppRouter;

